import IDetalhesViagemPedagioDTO from '../entities/IDetalhesViagemPedagioDTO'
import { IValePedagioRepository } from '../repositories/IValePedagioRepository'

export interface IFindDetalhesViagemComVPO {
  execute(id: number, documento: string): Promise<IDetalhesViagemPedagioDTO>
}

export default class FindDetalhesViagemComVPOImpl
  implements IFindDetalhesViagemComVPO
{
  constructor(private readonly repository: IValePedagioRepository) {}
  async execute(
    id: number,
    documento: string,
  ): Promise<IDetalhesViagemPedagioDTO> {
    return this.repository.findDetalhesViagemComVPO(id, documento)
  }
}
